const map = require('mn-utils/map');
module.exports = (items$) => {
  return 1 + Math.max(1, ...map(items$.getValue(), (v) => {
    return isNaN(v = parseInt(v.id)) ? 0 : v;
  }));
};
